window.theme = window.theme || {};
window.theme.scroll =
  window.theme.scroll ||
  (function () {
    let lastScrollPosition = 0;
    let scrollEnabled = true;

    const getScrollbarWidth = () =>
      window.innerWidth - document.documentElement.clientWidth;

    return {
      isEnabled() {
        return scrollEnabled;
      },
      disable: () => {
        const scrollbarWidth = getScrollbarWidth();
        scrollEnabled = false;
        lastScrollPosition = window.scrollY;
        document.body.style.top = -window.scrollY + "px";
        if (window.innerWidth > 576) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
        document.body.style.position = "fixed";
      },
      enable: () => {
        scrollEnabled = true;
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.paddingRight = "";
        window.scrollTo({
          top: lastScrollPosition,
          behavior: "instant",
        });
      },
    };
  })();

class SuperzoomImages extends HTMLElement {
  constructor() {
    super();
  }
  static get observedAttributes() {
    return ['index', 'mode'];
  }
  attributeChangedCallback(name, oldValue, value) {
    if(name === 'index' && oldValue !== value) {
      this.start();
    } else if (name === 'mode' && oldValue !== value && !!oldValue) {
      if(value === 'thumbnail') {
        window.theme.scroll.enable();
        this.querySelectorAll('superzoom-image').forEach(image => {
          image.removeZoom();
        });
      } else {
        if(window.innerWidth <= 768) {
          window.theme.scroll.disable();
        }
        this.thumbnails.checkScroll();
      }
    }
  }
  render() {
    this.viewport.innerHTML = '';
    this.thumbnails_content.innerHTML = '';
    this.config.image_views?.forEach(image_view => {
      let images_html = '';
      image_view.images?.forEach((image, index) => {
        const image_html = `<img 
          decode="sync" 
          fetchpriority="high"
          crossorigin="anonymous"
          data-index="${index}" 
          srcset="${image.src}&width=300 300w, ${image.src}&width=400 400w, ${image.src}&width=500 500w, ${image.src}&width=600 600w, ${image.src}&width=700 700w, ${image.src}&width=1500 1500w"
          src="${image.src}&width=400" 
          sizes="50vw"
          class="loading"
          loading="eager">`;
        images_html += image_html;
      });
      const image_view_html = `<superzoom-image class="loading" index="0" timeline="${image_view.timeline}" aria-label="${image_view.label}">${images_html}</superzoom-image>`;
      this.viewport?.insertAdjacentHTML('beforeend', image_view_html);
    });
    this.config.image_views?.forEach((image_view, index) => {
      const featured_image = image_view.images?.shift();
      if(!!featured_image) {
        const thumbnail_html = `<div class="thumbnail" data-index="${index}">
          <img 
          srcset="${featured_image.src}&width=150 150w, ${featured_image.src}&width=300 300w, ${featured_image.src}&width=450 450w"
          src="${featured_image.src}&width=150" 
          sizes="150px"
          class="loading"
          loading="eager">
          <p class="thumbnail-label">${image_view.label_translated ?? image_view.label ?? ''}</p>
        </div>`;
        this.thumbnails_content?.insertAdjacentHTML('beforeend', thumbnail_html);
      }
    });
  }
  parseConfig(node) {
    this.config = {};
    this.config.image_views = []
    const base = node.querySelector('FPX Base')?.getAttribute('value') ?? '';
    let Images = Array.from(node.querySelectorAll('Images Image'));
    if(Images.length < 1){
      Images.push(node);
    }
    Images?.forEach(Image => {
      const image_view = {};
      image_view.label = Image.getAttribute('label');
      image_view.localizationkey = Image.getAttribute('localizationkey');
      image_view.label_translated = this.translations?.[image_view.localizationkey]?.[this.locale];
      const timeline = Image.querySelector('Options SceneSets')?.getAttribute('value') ?? '';
      image_view.timeline = timeline;
      const images3d = Image.querySelector('images3d');
      const prefix = images3d?.getAttribute('prefix') ?? '';
      const suffix = images3d?.getAttribute('suffix') ?? '';
      image_view.images = [];
      images3d?.querySelectorAll('image').forEach(image => {
        const handle = image.getAttribute('src');
        const src = `${base}${prefix}${handle}${suffix}`;
        image_view.images.push({src: src});
      });
      this.config.image_views.push(image_view);
    });
  }
  stop() {
    this.querySelectorAll('superzoom-image').forEach(image => {
      image.stop();
    });
    this.play_button.setAttribute('mode', 'pause');
  }
  start() {
    const currentIndex = Number(this.getAttribute('index'));
    this.querySelectorAll('superzoom-image').forEach((image, index) => {
      if(index === currentIndex && image.zoom < 1) {
        if(image.complete) {
          image.start();
          this.play_button.setAttribute('mode', 'play');
        } else {
          image.addEventListener('load', () => {
            image.start();
            this.play_button.setAttribute('mode', 'play');
          });
        }
      } else {
        image.stop();
      }
    });
  }
  connectedCallback() {
    this.locale = this.getAttribute('locale');
    this.viewport = this.querySelector('.viewport');
    this.control_elements = this.querySelector('.control-elements');
    this.play_button = this.querySelector('.play-button');
    this.close_button = this.querySelector('.close');
    this.zoomin_button = this.querySelector('.zoom-in');
    this.zoomout_button = this.querySelector('.zoom-out')
    this.images = this.querySelectorAll('.superzoom-image');
    this.thumbnails = this.querySelector('.thumbnails');
    this.thumbnails_content = this.querySelector('.thumbnails-content');
    const configuration_src = this.getAttribute('src');
    const loadStart = Date.now();
    this.translations = this.querySelector('script[superzoom-translations]');
    if(!!this.translations) {
      this.translations = JSON.parse(this.translations.textContent);
    }
    if(!!configuration_src){
      fetch(configuration_src)
      .then(response => {
        if(response.ok){
          this.removeAttribute('style');
          return response.text()
        } else {
          console.error('Superzoom: configuration could not be loaded');
          this.remove();
        }
      })
      .then(str => new DOMParser().parseFromString(str, "text/xml"))
      .then(data => {
        this.parseConfig(data.documentElement);
        this.render();
        this.thumbnails.querySelectorAll('.thumbnail').forEach(thumbnail => {
          thumbnail.addEventListener('click', event => {
            const thumbnailIndex = thumbnail.dataset?.index;
            this.setAttribute('index', thumbnailIndex);
          });
        });
      }).catch(e=>{
        console.error(e);
        console.error('Superzoom: configuration could not be loaded');
        this.remove();
      });
    } else {
      console.warn('Superzoom: no configuration file provided!');
    }
    this.viewport.addEventListener('mousedown', event => {
      if(this.getAttribute('mode') === 'fullscreen') {
        event.stopPropagation();
      }
      this.mouseDownCache = {clientX: event.clientX, clientY: event.clientY, time: new Date()};
    });
    this.control_elements.addEventListener('click', event => {
      if(this.getAttribute('mode') === 'thumbnail') {
        this.setAttribute('mode', 'fullscreen');
        this.start();
      }
    });
    this.play_button.addEventListener('click', event => {
      if(this.play_button.getAttribute('mode') === 'play') {
        this.stop();
      } else {
        const currentIndex = Number(this.getAttribute('index'));
        this.querySelectorAll('superzoom-image')[currentIndex]?.removeZoom();
        this.start();
      }
    });
    this.close_button.addEventListener('click', event => {
      if(this.getAttribute('mode') === 'fullscreen') {
        this.setAttribute('mode', 'thumbnail');
        this.stop();
      }
    });
    this.zoomin_button.addEventListener('click', event => {
      const currentIndex = Number(this.getAttribute('index'));
      const currentImage = this.querySelectorAll('superzoom-image')[currentIndex];
      this.stop();
      currentImage.zoomIn();
    });
    this.zoomout_button.addEventListener('click', event => {
      const currentIndex = Number(this.getAttribute('index'));
      const currentImage = this.querySelectorAll('superzoom-image')[currentIndex];
      currentImage.zoomOut();
    });
  }
}
customElements.define('superzoom-images', SuperzoomImages);

class SuperzoomImage extends HTMLElement {
  constructor() {
    super();
  }
  static get observedAttributes() {
    return ['index', 'sizes'];
  }
  setActiveImage(index) {
    const image_index = this.timeline[index];
    this.images.forEach(image => Number(image.dataset.index) === image_index && image.complete && image.naturalWidth !== 0 ? image.classList.add('active') : image.removeAttribute('class'));
  }
  attributeChangedCallback(name, oldValue, value) {
    if(name === 'index' && !!oldValue){
      this.setActiveImage(Number(value));
    }
    if(name === 'sizes'){
      this.images.forEach(image => image.setAttribute('sizes', value));
    }
  }
  start() {
    if(this.paused && this.zoom < 1){
      this.paused = false;
      this.autoplay = setInterval(() => {
        const currentIndex = Number(this.getAttribute('index'));
        const nextIndex = currentIndex + 1;
        if(nextIndex < this.timeline.length) {
          this.setAttribute('index', nextIndex);
        } else {
          this.setAttribute('index', 0);
        }
      }, 150);
    }
  }
  stop() {
    if(!this.paused){
      clearInterval(this.autoplay);
      this.paused = true;
    }
  }
  waitForImagesToLoad() {
    return Promise.all(this.images.map(img => {
      if (img.complete)
        return Promise.resolve(img.naturalHeight !== 0);
      return new Promise(resolve => {
        img.addEventListener('load', () => resolve(true));
        img.addEventListener('error', () => resolve(false));
      });
    }))
  }
  decodeTimeline() {
    if(this.hasAttribute('timeline')){
      const timeline = [];
      const timeline_attribute = this.getAttribute('timeline');
      timeline_attribute?.split(',').forEach(interval => {
        if(interval.includes('-')) {
          const start = Number(interval.split('-').shift());
          const end = Number(interval.split('-').pop());
          if(start < end){
            for(let i = (start - 1); i < end; i++) {
              timeline.push(i);
            }
          } else if (start > end) {
            for(let i = (start - 1); i >= (end - 1); i--) {
              timeline.push(i);
            }
          } else {
            timeline.push(start - 1);
          }
        } else {
          timeline.push(Number(interval) - 1);
        }
      });
      return timeline;
    } else {
      return [...Array(this.imageCount).keys()];
    }
  }
  updateSizes() {
    this.classList.add('loading');
    const loadStart = Date.now();
    const currentIndex = this.timeline[Number(this.getAttribute('index'))];
    const currentImage = this.images[currentIndex];
    const boundingObject = !!currentImage ? currentImage : this;
    this.setAttribute('sizes', (100.0 * boundingObject.getBoundingClientRect().width / window.innerWidth).toFixed(1)+'vw');
    this.waitForImagesToLoad().then(() => {
      //console.log(`Superzoom images updated in ${Date.now() - loadStart}ms`);
      this.classList.remove('loading');
    })
  }
  zoomIn() {
    this.stop();
    const currentIndex = this.timeline[Number(this.getAttribute('index'))];
    const currentImage = this.images[currentIndex];
    this.zoom = Math.min(2, this.zoom + 1);
    this.dragEnd = {x: 0, y: 0};
    currentImage.style.translate = '';
    currentImage.style.scale = 1 + this.zoom * 0.5;
    this.classList.add('zoomed');
    this.updateSizes();
  }
  zoomOut() {
    const currentIndex = this.timeline[Number(this.getAttribute('index'))];
    const currentImage = this.images[currentIndex];
    this.zoom = Math.max(0, this.zoom - 1);
    this.dragEnd = {x: 0, y: 0};
    currentImage.style.translate = '';
    currentImage.style.scale = 1 + this.zoom * 0.5;
    if(this.zoom < 1) {
      this.images.forEach(image => {
        image.removeAttribute('style');
      });
      this.classList.remove('zoomed');
    }
    this.updateSizes();
  }
  removeZoom() {
    this.images.forEach(image => {
      image.removeAttribute('style');
    });
    this.zoom = 0;
    this.dragEnd = {x: 0, y: 0};
    this.classList.remove('zoomed');
  }
  moveZoom(pointerX, pointerY) {
    const currentIndex = this.timeline[Number(this.getAttribute('index'))];
    const currentImage = this.images[currentIndex];
    const boundingBox = this.getBoundingClientRect();
    const delta = {x: pointerX - this.dragStart.x, y: pointerY - this.dragStart.y};
    this.drag.x = Math.min(Math.max(this.dragEnd.x + (delta.x / boundingBox.width), -0.5 + this.zoom * -0.25), 0.5 + this.zoom * 0.25);
    this.drag.y = Math.min(Math.max(this.dragEnd.y + (delta.y / boundingBox.height), -0.5 + this.zoom * -0.25), 0.5 + this.zoom * 0.25);
    currentImage.style.translate = `${this.drag.x * 100}% ${this.drag.y * 100}%`;
  }
  rotate(pointerX) {
    this.stop();
    const play_button = this.wrapper?.querySelector('.control-elements .play-button');
    play_button?.setAttribute('mode', 'pause');
    const currentIndex = this.startIndex;
    const width = this.getBoundingClientRect().width;
    const distance = Math.abs((pointerX - this.dragStart.x) / width);
    const nextIndex = (currentIndex + Math.round(distance * this.timeline.length * 2)) % this.timeline.length;
    this.setAttribute('index', nextIndex);
  }
  connectedCallback() {
    this.classList.add('loading');
    this.wrapper = this.closest('superzoom-images');
    this.zoom = 0;
    this.drag = {x: 0, y: 0};
    this.dragStart = null;
    this.startIndex = null;
    this.dragEnd = {x: 0, y: 0};
    this.paused = true;
    this.complete = false;
    this.images = Array.from(this.querySelectorAll('img'));
    this.imageCount = this.images.length;
    this.timeline = this.decodeTimeline();
    const initialIndex = this.hasAttribute('index') ? Number(this.getAttribute('index')) : 0;
    const loadStart = Date.now();
    this.setAttribute('sizes', (100.0 * this.getBoundingClientRect().width / window.innerWidth).toFixed(1)+'vw');
    this.waitForImagesToLoad().then(() => {
      this.images.map(img => {
        img.setAttribute('width', img.naturalWidth); 
        img.setAttribute('height', img.naturalHeight);
      });
      // console.log(`Superzoom images loaded in ${Date.now() - loadStart}ms`);
      this.setActiveImage(initialIndex);
      this.complete = true;
      this.dispatchEvent(new Event('load'));
      this.classList.remove('loading');
    });
    this.addEventListener('pointerdown', event => {
      if(!this.dragStart){
        this.dragStart = {x: event.clientX, y: event.clientY};
        this.startIndex = Number(this.getAttribute('index'));
        this.setPointerCapture(event.pointerId);
      }
    });
    this.addEventListener('pointerup', event => {
      if(!!this.dragStart){
        this.dragStart = null;
        this.startIndex = null;
        this.dragEnd = {x: this.drag.x, y: this.drag.y};
        this.releasePointerCapture(event.pointerId);
      }
    });
    this.addEventListener('pointermove', event => {
      if(!!this.dragStart && this.zoom > 0){
        this.moveZoom(event.clientX, event.clientY);
      }
      if(!!this.dragStart && this.zoom < 1){
        this.rotate(event.clientX);
      }
    });
  }
  disconnectedCallback() {
    clearInterval(this.autoplay);
  }
}
customElements.define('superzoom-image', SuperzoomImage);

class SuperzoomThumbnails extends HTMLElement {
  constructor() {
    super();
  }
  prev() {
    this.content.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  next(){
    this.content.scrollTo({
      top: 5000,
      left: 0,
      behavior: "smooth",
    });
  }
  checkScroll() {
    if(this.content.scrollHeight > this.content.clientHeight){
      if(this.content.scrollTop > 0 && (this.content.scrollTop + this.content.clientHeight) < (this.content.scrollHeight - 5)) {
        this.setAttribute('scrollable', 'both');
      } else if(this.content.scrollTop > 0) {
        this.setAttribute('scrollable', 'up');
      } else if((this.content.scrollTop + this.content.clientHeight) < (this.content.scrollHeight - 5)) {
        this.setAttribute('scrollable', 'down');
      }
    } else {
      this.removeAttribute('scrollable');
    }
  }
  connectedCallback() {
    this.prevButton = this.querySelector('.prev-thumbnail');
    this.nextButton = this.querySelector('.next-thumbnail');
    this.content = this.querySelector('.thumbnails-content');
    this.resizeCallback = this.checkScroll.bind(this);
    window.addEventListener('resize', this.resizeCallback);
    this.content.addEventListener('scroll', this.resizeCallback);
    this.prevButton.addEventListener('click', this.prev.bind(this));
    this.nextButton.addEventListener('click', this.next.bind(this));
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeCallback);
  }
}
customElements.define('superzoom-thumbnails', SuperzoomThumbnails);